import { render, staticRenderFns } from "./BigFooter.vue?vue&type=template&id=22ab09e7&scoped=true&"
import script from "./BigFooter.vue?vue&type=script&lang=js&"
export * from "./BigFooter.vue?vue&type=script&lang=js&"
import style0 from "./BigFooter.vue?vue&type=style&index=0&id=22ab09e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab09e7",
  null
  
)

export default component.exports